<template>
  <!-- Äußeren Container so definieren, dass er den ganzen Bildschirm (oder einen definierten Bereich) einnimmt -->
  <div class="p-5 bg-trader-gray rounded flex flex-col gap-2 flex-grow">

    <!-- Info-Bereich -->
    <div class="flex flex-col text-black pb-5">
      <h2 class="text-2xl font-bold">
        Mailing (Top 5 Kunden Produkte)</h2>
      <span class="text-md">
        Dies ist der Standard-Excel-Import. Bitte wählen Sie die Datei aus, die Sie importieren möchten.
      </span>
      <span class="text-md">
        Sie können normale sowie auch regionale Magazine importieren.
      </span>
    </div>

    <TRProgress :progress="processed"></TRProgress>

    <!-- SELECTS (und weitere Eingaben) -->
    <div class="flex flex-col w-full gap-2">
      <!-- Datei -->
      <div class="flex">
        <span class="p-1 w-[150px]">Datei:</span>
        <label @change="onFileChange"
               class="text-center bg-trader-dark-gray hover:bg-trader-blue hover:text-white flex-grow rounded p-2">
          <input type="file" class="hidden">
          Datei auswählen
        </label>
      </div>
    </div>



  </div>
</template>

<script>
import {eventBus} from "@/application/EventBus.js";
import apolloClient from "@/apolloClient";
import {gql} from "@apollo/client/core";
import axios from "axios";
import Spinner from "@/components/Base/Spinner.vue";
import SignalBus from "@/application/SignalBus";
import {mutation, query} from "@/graphql";
import TRProgress from "@/components/Base/v2/TRProgress.vue";
import {mapState} from "vuex";

export default {
  components: {TRProgress, Spinner},

  props: {
    value: {
      type: Object,
      default: () => ({})
    },
  },
  data() {
    return {
      interval: null,
      jobId: null,
      processed: 0,
    };
  },
  computed: {
    ...mapState('user', ['userData']),
  },
  mounted() {
  },
  methods: {
    async onFileChange(event) {
      this.selectedFile = event.target.files[0];
      if (this.selectedFile) {
        const formData = new FormData();
        formData.append('file', this.selectedFile);
        formData.append('type', "mailing")
        const response = await axios.post('/api/v3/import/', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });
        if (response.data) {
          //console.log("response", response.data);
          this.jobId = response.data.jobId;

          this.interval = setInterval(async() => {
            const [data, err] = await query.getJop(this.jobId)


            if(data.report.success) {
              let filePath = data.report.messages[0].data[0].value;
              let downloadLink = document.createElement('a');
              downloadLink.href = '/api/v3/download/?file=' + encodeURIComponent(filePath);
              console.log(downloadLink.href);
              downloadLink.download = 'exported_mailing.xlsx';
              document.body.appendChild(downloadLink);
              downloadLink.click();
              document.body.removeChild(downloadLink);
              clearInterval(this.interval);
              this.interval = null;
              this.processed = 0
            }

            this.processed = data.processed

            if(err != null) {
              clearInterval(this.interval);
              this.interval = null;
            }
          }, 2000);


          setTimeout(() => {
            clearInterval(this.interval);
            this.interval = null;
          }, 1000 * 120); // Stop after 2 minutes



        }
      }
    },
  }
};
</script>
